import { cancel, cancelled, delay, fork, put, take } from 'redux-saga/effects';

import {
  START_CACHE_CLEAR_TASK,
  STOP_CACHE_CLEAR_TASK,
  CACHE_CLEAR_TASK_CANCELLATION,
} from './constants';
import { clearListingsCache } from './actions';

// filtered listings cache will be cleared upon routing to listings page
// however, if the user stays on the listings page for more than
// 15 minutes, we clear the cache
export function* backgroundCacheTask() {
  try {
    while (true) {
      yield delay(90000); // 15 minutes
      yield put(clearListingsCache());
    }
  } finally {
    if (yield cancelled()) {
      yield put({ type: CACHE_CLEAR_TASK_CANCELLATION });
    }
  }
}

export function* watchStartClearCacheTask() {
  while (yield take(START_CACHE_CLEAR_TASK)) {
    // starts the task in the background
    const bgCacheTask = yield fork(backgroundCacheTask);

    // wait for stop action
    yield take(STOP_CACHE_CLEAR_TASK);
    // stop triggered, cancel the background task
    // this will cause the forked backgroundCacheTask
    // task to jump into its finally block
    yield cancel(bgCacheTask);
  }
}
